import {
  IPermissionState,
  PermissionAction,
  ReduxPermissionActionType,
} from './model';
import { StudioInitState } from './state';

export const permissionReducer = (
  state = StudioInitState,
  action: PermissionAction
): IPermissionState => {
  switch (action.type) {
    case ReduxPermissionActionType.SET_PERMISSION: {
      const newState = { ...state };
      Object.assign(newState.studioPrem, action.result.studioPrem);
      Object.assign(newState.gamePerm, action.result.gamePerm);
      Object.assign(newState.envPerm, action.result.envPerm);
      return newState;
    }

    case ReduxPermissionActionType.CLEAR_PERMISSION: {
      return { studioPrem: {}, gamePerm: {}, envPerm: {} };
    }

    default:
      return state;
  }
};
